import { CardSkeleton, SectionHeadingSkeleton, SkeletonElement } from "@/components/Skeleton";

export default function UpdateBeneficiariesFormSkeleton() {
  return (
    <div className="flex flex-col" data-testid="update-beneficiaries-form-skeleton">
      <div className="flex flex-col">
        <SectionHeadingSkeleton />
        <CardSkeleton className="!w-full rounded-[16px]" rows={6} width={100} />
        <div className="self-start py-4">
          <SkeletonElement height="h-10" width="w-56" />
        </div>
      </div>

      <div className="flex flex-col">
        <SectionHeadingSkeleton />
        <div className="self-start py-4">
          <SkeletonElement height="h-10" width="w-60" />
        </div>
      </div>
    </div>
  );
}
